import { useEffect } from 'react';
import { useMatches, type Params } from 'react-router';
import { isMarket, screenOfHandle, screens, screenTitle, type Screen, type ScreenId } from './routes';

export const appName = 'Trader';

export type CurrentScreen = { id: ScreenId; screen: Screen; params: Params };

/** The screen of the deepest matched route that names one in its handle. */
export function useCurrentScreen(): CurrentScreen | null {
  const matches = useMatches();

  for (let index = matches.length - 1; index >= 0; index--) {
    const match = matches[index];
    const id = screenOfHandle(match?.handle);
    if (id && match) return { id, screen: screens[id], params: match.params };
  }

  return null;
}

/** The current page's title, from its route handle. A URL with an unknown market is "Not found". */
export function usePageTitle(): string {
  const current = useCurrentScreen();
  if (!current) return appName;
  if ('market' in current.params && !isMarket(current.params.market)) return screenTitle('notFound', current.params);
  return screenTitle(current.id, current.params);
}

/** "Groups · Trader" in the browser tab and the iOS app switcher. */
export function documentTitle(title: string): string {
  return title && title !== appName ? `${title} · ${appName}` : appName;
}

export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = documentTitle(title);
  }, [title]);
}
